import * as React from 'react';
import { AutocompletePicker } from 'app/components/BasicPickers/AutocompletePicker';
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/translations';
import { AutomaticAssetImportNaming } from './Types';

export function AutomaticAssetImportNamingPicker(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  return (
    <AutocompletePicker
      loadData={() =>
        Promise.resolve([
          { Id: AutomaticAssetImportNaming.NA as number, Name: 'N/A' },
          {
            Id: AutomaticAssetImportNaming.ByAssetCatModelNumber as number,
            Name: t(translations.ByAssetCatModelNumber),
          },
        ])
      }
      variant="filled"
      fullWidth
      {...props}
    />
  );
}
